"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const L = __importStar(require("leaflet"));
const map = L.map("map_vehicules_relais", { zoomControl: false }).setView([46.2276, 2.2137], 6);
// Add credits to map
L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    referrerPolicy: "strict-origin-when-cross-origin",
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
}).addTo(map);
/* Info box on the top right */
class InfoBox extends L.Control {
    constructor() {
        super({ position: "topright" });
        this.onAdd = () => {
            this.update(null);
            return this._div;
        };
        this.update = (props) => {
            const title = props
                ? `${props.nom} (${props.code_insee})`
                : `Nombre de taxis relais`;
            const content = props
                ? this.getInfoboxContent(props.vehicules_relais_count)
                : `Survolez un département pour <br/>afficher le nombre de taxis relais enregistrés`;
            this._div.innerHTML = `
          <div class="fr-tile fr-enlarge-link fr-tile--horizontal" style="opacity: 0.8">
            <div class="fr-tile__body">
                <h4 class="fr-tile__title">${title}</h4>
                <p class="fr-tile__desc">${content}</p>
            </div>
        </div>
        `;
        };
        this.getInfoboxContent = (vehicules_relais_count) => {
            return `${vehicules_relais_count} taxis relais ${vehicules_relais_count > 1 ? "enregistrés" : "enregistré"}`;
        };
        this._div = L.DomUtil.create("div", "leaflet-info");
    }
}
function displayStatsMap(data) {
    const info = new InfoBox().addTo(map);
    const geojson = L.geoJSON(data, {
        onEachFeature: (feature, layer) => {
            const center = layer.getBounds().getCenter();
            if (feature.properties.vehicules_relais_count !== 0) {
                const label = L.divIcon({
                    className: "vehicule-count-label",
                    html: `
        <div style="
          display: flex;
          justify-content: center;
          background-color: #000066;
          align-items: center;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          color: white;
        ">
          ${feature.properties.vehicules_relais_count}
        </div>
      `,
                });
                L.marker(center, { icon: label }).addTo(map);
            }
            layer.on({
                mouseover: () => {
                    layer.setStyle({
                        fillOpacity: 0.4,
                    });
                    info.update(feature.properties);
                },
                mouseout: (e) => {
                    geojson.resetStyle(e.target);
                    info.update(null);
                },
                click: () => {
                    map.fitBounds(layer.getBounds());
                    info.update(feature.properties);
                },
            });
        },
    }).addTo(map);
}
// Call API to display stats
fetch("/api/stats/geojson/per-prefecture/")
    .then((response) => response.json())
    .then(displayStatsMap);
